import SbButton from '@Components/Button';
import Image from '@Components/Image';
import { SBTable } from '@Components/Table/Table';
import { TableHeadCell, TableRowCell } from '@Components/Table/TableCell';
import { SBTableRow } from '@Components/Table/TableRow';
import { ServiceAndCarrierState, ServiceObj } from '@Reducers/CarrierAndService/Type';
import { PayloadMarkup, RateState } from '@Reducers/RateSummary/Type';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import { SystemState } from '@Reducers/Systems/Type';
import { downloadUserRateSheet } from '@Reducers/UserRateSheetDownload/UserRateSheetDownload';
import { toggleBoolean } from '@Reducers/booleanSlice/booleanSlice';
import { AppDispatch, RootStateType } from '@Store';
import { Stack, TableBody, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useSystemCspHashById() {
  const cspObj = useSelector<RootStateType>(
    state => state.carrierAndService.serviceListHashById,
  ) as ServiceAndCarrierState['serviceListHashById'];

  const systemObj = useSelector<RootStateType>(
    state => state.System.activeSystemListHashById,
  ) as SystemState['activeSystemListHashById'];

  return [cspObj, systemObj];
}
interface RatesTableType {
  navigatedDate: string;
}

export function RatesTable(Props: RatesTableType) {
  const { navigatedDate } = Props;
  const dispatch = useDispatch<AppDispatch>();
  const RateState = useSelector((state: RootStateType) => state.RateSummary);
  const userBaseRateSheetDownloadStatus = useSelector(
    (state: RootStateType) => state.userBasePricingRateSheetDownload.downloadStatus,
  );
  const [cspHashByid, systemHashById] = useSystemCspHashById();
  const RateConfig = useSelector<RootStateType>(state => state.RateSummary.config) as RateState['config'];

  const onDownload = async (rate: PayloadMarkup) => {
    dispatch(
      downloadUserRateSheet({
        rate,
        RateState,
        RateConfig,
        navigatedDate,
      }),
    );
  };

  useEffect(() => {
    if (userBaseRateSheetDownloadStatus === 'loading') {
      dispatch(
        SuccessErrorModalOpen({
          type: 'success',
          title: 'Download in Progress',
          subTitle: 'It will be available shortly in the downloads bar',
          btnText: 'Close',
          onConfirm: () => {
            dispatch(toggleBoolean());
            dispatch(SuccessErrorModalReset());
          },
        }),
      );
    }
  }, [userBaseRateSheetDownloadStatus]);

  return (
    <SBTable>
      <TableHead>
        <TableRow>
          <TableHeadCell>Services</TableHeadCell>
          <TableHeadCell>System </TableHeadCell>
          <TableHeadCell>Parcel </TableHeadCell>
          <TableHeadCell>Document </TableHeadCell>
          <TableHeadCell>Validity </TableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {RateState.selectedDateRate.map((rate: PayloadMarkup, index) => {
          const serviceObj = cspHashByid?.[rate.csp] as ServiceObj;
          return (
            <SBTableRow key={index}>
              <TableRowCell align="center" className="sm-text">
                <Stack direction={'row'} gap={'1rem'} alignItems={'center'}>
                  <Stack justifyContent={'center'} alignItems={'center'} className="p-2 border-1px border-grey rounded">
                    <Image
                      src={serviceObj?.logo}
                      alt={serviceObj?.name}
                      width={83}
                      height={59}
                      style={{ objectFit: 'contain' }}
                    />
                  </Stack>
                  <div>{serviceObj?.name}</div>
                </Stack>
              </TableRowCell>
              <TableRowCell
                sx={{
                  justifyContent: 'center',
                }}
                align="center"
                className="sm-text text-center"
              >
                {systemHashById?.[rate.system]?.name}
              </TableRowCell>
              <TableRowCell align="center" className="sm-text">
                {!rate.documentRates ? (
                  <SbButton
                    onClick={() => {
                      onDownload(rate);
                    }}
                    // fullWidth
                    variant="contained"
                    sx={{
                      borderRadius: '8px !important',
                      fontWeight: 500,
                      color: 'common.black',
                      backgroundColor: 'primary.light',
                      boxShadow: 'none',
                      ':hover': {
                        color: 'common.black',
                        backgroundColor: 'primary.light',
                        boxShadow: 'none',
                      },
                    }}
                    endIcon={<Image src={'/images/file_download.svg'} alt={'Speedbox'} width={20} height={20} />}
                  >
                    Rate sheet
                  </SbButton>
                ) : (
                  '----'
                )}
              </TableRowCell>
              <TableRowCell align="center" className="sm-text">
                {rate.documentRates ? (
                  <SbButton
                    onClick={() => onDownload(rate)}
                    // fullWidth
                    variant="contained"
                    sx={{
                      borderRadius: '8px !important',
                      color: 'common.black',
                      fontWeight: 500,
                      backgroundColor: 'primary.light',
                      boxShadow: 'none',
                      ':hover': {
                        color: 'common.black',
                        backgroundColor: 'primary.light',
                        boxShadow: 'none',
                      },
                    }}
                    endIcon={<Image src={'/images/file_download.svg'} alt={'Speedbox'} width={20} height={20} />}
                  >
                    Rate sheet
                  </SbButton>
                ) : (
                  '----'
                )}
              </TableRowCell>
              <TableRowCell align="center" className="md-text">
                {moment(rate.endDate).format('DD/MM/YYYY')}
              </TableRowCell>
            </SBTableRow>
          );
        })}
      </TableBody>
    </SBTable>
  );
}
